module.exports = __webpack_public_path__ + "static/media/consulting-image-3.6a0b76f4.png";